module.exports = {
  siteTitle: 'TrustKit Analytics',
  siteSubtitle: '(Free-Forever Edition)',

  attacks: {
    ordering: [
      'device_spyware',
      'corporate_appliance',
      'captive_portal',
      'unknown',
      'misconfiguration'
    ],
    catMapping: {
      'device_spyware': 'User Device Spyware',
      'captive_portal': 'Insecure Public WiFi',
      'misconfiguration': 'App Misconfiguration',
      'corporate_appliance': 'Employer Eavesdropping',
      'unknown': 'Unknown Actors',
      'projection': 'Additional Projected (by end-of-month)'
    },
    catColors: {
      'device_spyware': '#EF476F',
      'captive_portal': '#26547C',
      'misconfiguration': '#FFD166',
      'corporate_appliance': '#06D6A0',
      'unknown': '#E6AA68'
    }
  },

};


// WEBPACK FOOTER //
// ./site-config.js